import { Quotes, Star } from '@phosphor-icons/react';

const REVIEWS = [
  { id: 1, name: 'Mark Wagner', role: 'Founder of Disputifier', quote: "The service at Velocity is bar-none. They're truly invested in long term relationships and will move mountains to ensure that you're happy. Wouldn't use another 3PL ever.", image: '/lp/Testimonial_photos/MarkWagner.png' },
  { id: 2, name: 'Damon Dixon', role: 'Founder of Douxds', quote: "Velocity made it very easy for us to move our fulfillment from China to Miami. They also got me started on Amazon which unlocked another stream of revenue.", image: '/lp/Testimonial_photos/DamonDixon.png' },
  { id: 3, name: 'Hugo Contreras', role: 'Founder of Paraiso Creations', quote: "These guys are super organized and really pay attention to the details. As we added more SKUs and scaled, they made the process feel simple and stress free.", image: '/lp/Testimonial_photos/HugoContrerasJr.png' },
];

function TestimonialCard({ review }) {
  return (
    <div data-testid={`testimonial-card-${review.id}`} className="flex-shrink-0 w-[380px] bg-[#0f1319] border border-white/8 rounded-2xl p-7 hover:border-[#07c28e]/20 transition-all duration-300">
      <div className="flex items-center gap-0.5 mb-4">
        {[...Array(5)].map((_, i) => <Star key={i} size={14} weight="fill" className="text-[#07c28e]" />)}
      </div>
      <Quotes size={24} weight="fill" className="text-[#07c28e]/15 mb-2" />
      <p className="text-sm text-white/50 leading-relaxed mb-6">{review.quote}</p>
      <div className="flex items-center gap-3 pt-4 border-t border-white/5">
        <img src={review.image} alt={review.name} className="w-10 h-10 rounded-full object-cover border border-[#07c28e]/20" />
        <div>
          <p className="text-sm font-bold text-white">{review.name}</p>
          <p className="text-xs text-white/30">{review.role}</p>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const doubled = [...REVIEWS, ...REVIEWS, ...REVIEWS, ...REVIEWS];
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-14 sm:py-20 lg:py-28 overflow-hidden" style={{ background: 'linear-gradient(180deg, #191E29, #132D46 50%, #191E29)' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-12">
        <p className="text-xs font-bold text-[#07c28e] tracking-[0.2em] uppercase mb-3">Customer Stories</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight max-w-2xl">
          Don't just take our word for it — see why brands <span className="text-[#07c28e]">trust Velocity.</span>
        </h2>
      </div>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#1c2435] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#1c2435] to-transparent z-10 pointer-events-none" />
        <div className="flex gap-6 animate-scroll-testimonials w-max px-6">
          {doubled.map((r, i) => <TestimonialCard key={`${r.id}-${i}`} review={r} />)}
        </div>
      </div>
    </section>
  );
}
